import React from 'react'

import { ProductsProvider } from './src/store/index'

export const wrapRootElement = ({ element }) => (
  <ProductsProvider>{element}</ProductsProvider>
)
